var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card border-left-0 border-right-0 border-bottom-0 mb-4"},[_c('div',{staticClass:"card-header bg-white d-flex justify-content-between align-items-center"},[_c('h3',{staticClass:"m-0"},[_vm._t("title")],2),_vm._v(" "),_c('div',[_vm._t("actions")],2)]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }